import { render, staticRenderFns } from "./classifyListOnline.vue?vue&type=template&id=6a5cab4a&scoped=true&"
import script from "./classifyListOnline.vue?vue&type=script&lang=js&"
export * from "./classifyListOnline.vue?vue&type=script&lang=js&"
import style0 from "./classifyListOnline.vue?vue&type=style&index=0&id=6a5cab4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5cab4a",
  null
  
)

export default component.exports